import React from "react";
import { Box, IconButton, Typography, Tooltip } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { formatTime } from "./utils";

interface VideoControlsProps {
  isPlaying: boolean;
  setIsPlaying: (isPlaying: boolean) => void;
  currentTime: number;
  duration: number;
  trimStart: number;
  setCurrentTime: (time: number) => void;
}

const VideoControls: React.FC<VideoControlsProps> = ({
  isPlaying,
  setIsPlaying,
  currentTime,
  duration,
  trimStart,
  setCurrentTime,
}) => {
  const togglePlayPause = () => {
    setIsPlaying(!isPlaying);
  };

  const resetToStart = () => {
    setCurrentTime(trimStart);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        bgcolor: "background.paper",
        borderRadius: 2,
        px: 1,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Tooltip title={isPlaying ? "Pause" : "Play"}>
          <IconButton onClick={togglePlayPause} color="primary" size="medium">
            {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
          </IconButton>
        </Tooltip>

        <Tooltip title="Reset to start position">
          <IconButton onClick={resetToStart} size="small" sx={{ mx: 0.5 }}>
            <RestartAltIcon fontSize="small" />
          </IconButton>
        </Tooltip>

        <Typography variant="body2" sx={{ ml: 1, userSelect: "none" }}>
          {formatTime(currentTime)} / {formatTime(duration)}
        </Typography>
      </Box>
    </Box>
  );
};

export default VideoControls;
